module.exports = __webpack_public_path__ + "static/media/increase.13660587.png";